








































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Button, Card, Form, FormItem, Option, Select } from 'element-ui';
import { CustomerOrganizationFields, CustomerOrganizationInput } from '@/types/graphql/schemaTypes';
import { customerOrganizationService } from '@/services/CustomerOrganizationService';
import {
  dutyTaxPaymentTermsOptions,
  exportPaymentTermsOptions,
  importPaymentTermsOptions
} from '@/constants/paymentTerms.ts';

@Component({
  components: {
    'el-button': Button,
    'el-card': Card,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-option': Option,
    'el-select': Select
  }
})
export default class PaymentTerms extends Vue {
  @Prop({ required: true }) private customerOrganization!: CustomerOrganizationFields;

  private customerOrganizationInput: CustomerOrganizationInput | null = null;
  private editing = false;
  private loading = false;
  private readonly dutyTaxPaymentTermsOptions = dutyTaxPaymentTermsOptions();
  private readonly exportPaymentTermsOptions = exportPaymentTermsOptions();
  private readonly importPaymentTermsOptions = importPaymentTermsOptions();

  private setInput() {
    this.editing = true;
    this.customerOrganizationInput = {
      dutyTaxPaymentTerms: this.customerOrganization.dutyTaxPaymentTerms,
      exportPaymentTerms: this.customerOrganization.exportPaymentTerms,
      id: this.customerOrganization.id,
      importPaymentTerms: this.customerOrganization.importPaymentTerms
    };
  }

  private async submit() {
    if (!this.customerOrganizationInput) {
      return;
    }

    try {
      const response = await customerOrganizationService
        .updateCustomerOrganization(this.customerOrganizationInput);

      this.loading = true;
      if (response) {
        this.editing = false;
        this.$emit('refresh');
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.loading = false;
    }
  }
}
